const GET = (value) => ({ _tag: "GET", value });
const POST = (value) => ({ _tag: "POST", value });
const PUT = (value) => ({ _tag: "PUT", value });
const PATCH = (value) => ({ _tag: "PATCH", value });
const DELETE = (value) => ({
    _tag: "DELETE",
    value,
});
export const isGetRequest = (req) => req._tag === "GET";
export const isPostRequest = (req) => req._tag === "POST";
export const isPutRequest = (req) => req._tag === "PUT";
export const isPatchRequest = (req) => req._tag === "PATCH";
export const isDeleteRequest = (req) => req._tag === "DELETE";
export const getRequest = (path, headers = {}, credentials = true) => GET({
    path,
    headers,
    credentials,
});
export const deleteRequest = (path, headers = {}, credentials = true) => DELETE({
    path,
    headers,
    credentials,
});
export const putRequest = (path, body, headers = {}, credentials = true) => PUT({
    path,
    body,
    headers,
    credentials,
});
export const postRequest = (path, body, headers = {}, credentials = true) => POST({
    path,
    body,
    headers,
    credentials,
});
export const patchRequest = (path, body, headers = {}, credentials = true) => PATCH({
    path,
    body,
    headers,
    credentials,
});
export const withHeaders = (headers, r) => (Object.assign(Object.assign({}, r), { value: Object.assign(Object.assign({}, r.value), { headers: Object.assign(Object.assign({}, r.value.headers), headers) }) }));
export const withCredentials = (r, credentials) => (Object.assign(Object.assign({}, r), { value: Object.assign(Object.assign({}, r.value), { credentials: credentials }) }));
export const mapPath = (g, r) => (Object.assign(Object.assign({}, r), { value: Object.assign(Object.assign({}, r.value), { path: g(r.value.path) }) }));
export const getMethod = (r) => r._tag;

